import { useQuery } from '@tanstack/react-query';

import { AUTH_API } from '@/shared/api/amplify';
import { inIframe } from '@/shared/lib/browser';

import { USER_QUERY_KEYS } from '../lib/userQueryKeys';

type UseCognitoCheckUserProps = {
  enabled?: boolean;
  onSuccess?: () => void;
};

type UseCognitoCheckUser = {
  name?: string;
  cognitoId?: string;
  emailVerified?: string;
  isAuthorized: boolean;
  isUsedSocialProviders?: boolean;
  picture?: string;
};

export const useCognitoCheckUser = (props?: UseCognitoCheckUserProps) => {
  const { enabled, onSuccess } = props || {};

  return useQuery<UseCognitoCheckUser>({
    enabled,
    queryFn: async () => {
      if (inIframe()) {
        return {
          isAuthorized: true,
        };
      } else {
        try {
          const response = await AUTH_API.checkUser();
          const idToken = response?.getSignInUserSession()?.getIdToken();
          const token = idToken?.getJwtToken();

          if (token) {
            onSuccess?.();

            return {
              // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
              name: idToken?.payload.name,
              // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
              cognitoId: idToken?.payload.sub,
              // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
              emailVerified: idToken?.payload.email_verified,
              isAuthorized: true,
              isUsedSocialProviders: Boolean(idToken?.payload.identities?.length),
              // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
              picture: idToken?.payload.picture,
            };
          }
          return {
            isAuthorized: false,
          };

          // we need a catch block, because if a user is not authorized, there will be an error here
          // eslint-disable-next-line no-empty
        } catch {
          return {
            isAuthorized: false,
          };
        }
      }
    },
    queryKey: USER_QUERY_KEYS.cognitoUser,
  });
};
